import { Column, Img, Row, Section } from '@react-email/components'

import { borderRadius } from 'ms-email/themes/border-radius'

export function Mapstack() {
  return (
    <Section>
      <Row>
        <Column style={{ height: 32 }}>
          <Img
            alt='mapstack logo'
            style={{
              borderRadius: borderRadius.rounded
            }}
            src={`${process.env.NEXT_PUBLIC_MS_ASSETS_URL}/public/emails/logos/icon-mapstack-32px.png`}
            height={32}
          />
        </Column>
      </Row>
    </Section>
  )
}
